import { ArticleViewProps } from "@views/Article";
import { CategoryViewProps } from "@views/Category";
import { GetServerSideProps } from "next";

import { CollectionViewProps } from "@app/views/Collection";
import { DynamicView } from "@app/views/Dynamic";
import { getDynamicPageServerSideProps } from "@utils/ssr";

export default DynamicView;

export const getServerSideProps: GetServerSideProps<
  ArticleViewProps | CategoryViewProps | CollectionViewProps,
  | ArticleViewProps["params"]
  | CategoryViewProps["params"]
  | CollectionViewProps["params"]
> = async (props) => getDynamicPageServerSideProps(props);
